import React,{useState,useEffect,useRef} from 'react';
import PDFViewer from '../../SharedModule/PDF/PDFViewer';
import AdminPDF from '../../SharedModule/PDF/Admin Help Documentation.pdf';
import MemberPDF from '../../SharedModule/PDF/Member Registration Help Documentation.pdf';
import AppPDF from '../../SharedModule/PDF/Third-Party App Help Documentation.pdf';
import MemberConsentPDF from '../../SharedModule/PDF/Member Consent Help Documentation.pdf';
import MemberRestrictionPDF from '../../SharedModule/PDF/Member Restriction Help Documentation.pdf';
import queryString from 'query-string';

const Help=(props)=>{
   const [moduleName,setModulename]=useState("");
   const viewerRef = useRef(null);
   let docName=localStorage.getItem("ioxHelpDoc");
   useEffect(()=>{
      // setModulename(queryString.parse(props.location.search).name);
      setModulename(docName);
   },[])

   useEffect(() => {
   if (!viewerRef.current) return;

   const addAccessibleNames = () => {
      const links = viewerRef.current.querySelectorAll("a.internalLink, a.externalLink");

      links.forEach((link, index) => {
         const text = link.textContent && link.textContent.trim();
         const ariaLabel = link.getAttribute("aria-label");
         const title = link.getAttribute("title");

         if (!text && !ariaLabel) {
            link.setAttribute("aria-label", `PDF link ${index + 1}`);
         }
         if (!title) {
            link.setAttribute("title", `PDF link ${index + 1}`);
         }
      });
   };

   addAccessibleNames();

   const observer = new MutationObserver(() => {
      addAccessibleNames();
   });

   observer.observe(viewerRef.current, {
      childList: true,
      subtree: true
   });

   return () => observer.disconnect();
}, [moduleName]);
   return (
   <div className="content-wrapper">
      <div className="page-header mob-main-head">
         <h2 className="page-heading float-left">Help Documentation</h2>
         <div className="clearfix"></div>
      </div>
      <div className="tab-body-bordered pt-3">
         <div className="block-elm container-space" ref={viewerRef}>
            <PDFViewer PDF={moduleName == "app" ? AppPDF :
            moduleName == "admin" ? AdminPDF :
            moduleName == "member" ? MemberPDF :
            moduleName == "memberConsent" ? MemberConsentPDF :
            moduleName == "memberRestriction" ? MemberRestrictionPDF :
            null }/>
         </div>
      </div>
   </div>
   )
}

export default Help;